"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isRTL = function () {
    if (typeof document === "undefined")
        return;
    return (window.getComputedStyle(document.body).getPropertyValue("direction") ===
        "rtl");
};
exports.default = isRTL;
